import { getPlatform } from "@web/src/app/utils/platform";

export function shortcutLocalise(shortcut: string, verbose = false) {
  const isMac = getPlatform() === "macos";
  const shortcutMap: Record<string, string> = {
    mod: isMac ? "⌘" : "Ctrl",
    tab: "Tab",
    alt: isMac ? "⌥" : "Alt",
    shift: "⇧",
    enter: "↵",
    backspace: "⌫",
    arrowleft: "←",
    arrowright: "→",
    arrowup: "↑",
    arrowdown: "↓",
    left: "←",
    right: "→",
    up: "↑",
    down: "↓",
    esc: "Esc",
    arrow_keys: "← ↑ ↓ →",
  };

  const verboseMap: Record<string, string> = {
    mod: "Cmd",
    alt: isMac ? "Opt" : "",
    shift: "Shift",
    enter: "Enter",
    backspace: "Backspace",
    arrow_keys: "Arrows",
  };

  const str = shortcutMap[shortcut.toLowerCase()] || shortcut;

  if (!verbose) return str;

  // return `${verboseMap[shortcut.toLowerCase()] ?? ""} ${str}`;
  return ` ${str} ${verboseMap[shortcut.toLowerCase()] ?? ""}`;
}
